const About = () => <h2>About Page</h2>;
export default About;
